import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import DateFnsUtils from '@date-io/date-fns'
import esLocale from 'date-fns/locale/es'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import { ArrowRight, Calendar, RefreshCw } from 'lucide-react'
import i18n from '../../../assets/i18n'
import { tokens } from '../../../assets/tokens'
import DateRangePikerStyled from './styled'

// Rango de fechas con el mismo selector que los modales (DateInput, MUI pickers) en lugar de
// react-dates. La API no cambia: las fechas entran y salen como moment, o null al vaciarlas.
const toDate = value => (value && moment(value).isValid() ? moment(value).toDate() : null)

const DateRangePiker = ({
  startDate,
  onStartDateChange,
  endDate,
  onEndDateChange,
  onFocusChange,
  onSubmit,
  isFetching,
  showButton = true,
  disabled = false
}) => {
  // Mientras se escribe a mano el picker manda fechas inválidas: solo se propagan las completas
  const handleChange = callback => date => {
    if (!callback) return
    if (date === null) return callback(null)
    if (!isNaN(date.getTime())) callback(moment(date))
  }

  const pickerProps = {
    autoOk: true,
    disableToolbar: true,
    variant: 'inline',
    inputVariant: 'outlined',
    format: 'dd/MM/yyyy',
    disabled: disabled || isFetching,
    keyboardIcon: <Calendar size={18} color={tokens.color.text.tertiary} />,
    KeyboardButtonProps: { size: 'small' },
    className: 'date-field',
    onClose: () => onFocusChange && onFocusChange({ focused: '' })
  }

  const start = toDate(startDate)
  const end = toDate(endDate)

  return (
    <DateRangePikerStyled>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
        <KeyboardDatePicker
          {...pickerProps}
          id="startDate_id"
          value={start}
          placeholder={i18n.statisticsItems.startDate}
          onChange={handleChange(onStartDateChange)}
          onOpen={() => onFocusChange && onFocusChange({ focused: 'startDate' })}
          maxDate={end || undefined}
        />
        <ArrowRight size={16} className="separator" color={tokens.color.text.tertiary} />
        <KeyboardDatePicker
          {...pickerProps}
          id="endDate_id"
          value={end}
          placeholder={i18n.statisticsItems.endDate}
          onChange={handleChange(onEndDateChange)}
          onOpen={() => onFocusChange && onFocusChange({ focused: 'endDate' })}
          minDate={start || undefined}
        />
      </MuiPickersUtilsProvider>
      {showButton && (
        <button type="button" className={`submit ${isFetching ? 'rotate' : ''}`} onClick={onSubmit} disabled={isFetching}>
          <RefreshCw size={18} />
        </button>
      )}
    </DateRangePikerStyled>
  )
}

DateRangePiker.propTypes = {
  startDate: PropTypes.object,
  onStartDateChange: PropTypes.func,
  endDate: PropTypes.object,
  onEndDateChange: PropTypes.func,
  focused: PropTypes.string,
  onFocusChange: PropTypes.func,
  onSubmit: PropTypes.func,
  isFetching: PropTypes.bool,
  showButton: PropTypes.bool,
  disabled: PropTypes.bool
}

export default DateRangePiker
